import React from "react";

import { Combobox } from "@replo/design-system/components/combobox/Combobox";
import { MenuItem } from "@replo/design-system/components/menu/MenuItem";
import { ChevronDown } from "lucide-react";

interface BorderStyleSelectorProps {
  borderStyle: string | null;
  onSelect: (style: string | null) => void;
}

const BORDER_STYLE_OPTIONS = [
  {
    value: "none",
    label: "None",
    displayValue: "None",
  },
  {
    value: "solid",
    label: "Solid",
    displayValue: "Solid",
  },
  {
    value: "dashed",
    label: "Dashed",
    displayValue: "Dashed",
  },
  {
    value: "dotted",
    label: "Dotted",
    displayValue: "Dotted",
  },
  {
    value: "double",
    label: "Double",
    displayValue: "Double",
  },
] as const;

const BorderStyleSelector: React.FC<BorderStyleSelectorProps> = ({
  borderStyle,
  onSelect,
}) => {
  const currentStyleOption = BORDER_STYLE_OPTIONS.find(
    (option) => option.value === borderStyle,
  );

  const styleOptions = BORDER_STYLE_OPTIONS.map((style) => ({
    ...style,
    label: (
      <MenuItem
        variant="default"
        size="sm"
        selected={borderStyle === style.value}
      >
        {style.label}
      </MenuItem>
    ),
  }));

  return (
    <div className="border-style-selector">
      <Combobox.Root
        options={styleOptions}
        value={borderStyle ?? "none"}
        onChange={onSelect}
      >
        <Combobox.Trigger>
          <Combobox.SelectionButton
            layoutClassName="w-full"
            title={currentStyleOption?.displayValue ?? "None"}
            isPlaceholder={!borderStyle || borderStyle === "none"}
            size="sm"
            endEnhancer={<ChevronDown size={12} className="text-muted" />}
            titleAlignment="start"
          />
        </Combobox.Trigger>
        <Combobox.Popover
          sideOffset={8}
          side="right"
          align="center"
          layoutClassName="w-[140px]"
        >
          <Combobox.Content
            title="Border Style"
            areOptionsSearchable
            emptySearchMessage="No matches found"
          />
        </Combobox.Popover>
      </Combobox.Root>
    </div>
  );
};

export default BorderStyleSelector;
